// TODO:publish separately
export default !!(typeof window !== 'undefined' && window.document && window.document.createElement);